import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Grid, Divider } from "@mui/material";
import React from "react";
import { ToolbarFieldConfig, TFilterFieldsLocal } from "../ToolbarSinisterGeneric";

const SUBSTATUS_VALUES = ["preventive", "judicial", "extrajudicial"];

type Props = {
	field: ToolbarFieldConfig;
	filters: TFilterFieldsLocal;
	setFilter: (key: string, value: any) => void;
	getLabelFromValue: (value: string, field?: ToolbarFieldConfig) => string;
	onChangeExternal?: (value: any, filters: TFilterFieldsLocal, setFilter: (key: string, value: any) => void) => void;
};

export function renderSelectField({ field, filters, setFilter, getLabelFromValue, onChangeExternal }: Props): React.ReactNode {
	const value = filters[field.key] ?? field.defaultValue ?? "";
	const isMultiple = !!field.extraProps?.multiple;

	return (
		<Grid item key={field.key}>
			<FormControl size="small" fullWidth {...field.extraProps}>
				<InputLabel>{field.label}</InputLabel>
				<Select
					multiple={isMultiple}
					label={field.label}
					value={isMultiple ? (Array.isArray(value) ? value : []) : typeof value === "string" ? value : ""}
					onChange={(e) => {
						if (isMultiple) {
							let incoming = e.target.value as string[];
							let newValue = incoming.map((v) => v.trim());

							const includesTodos = newValue.includes("Todos");
							const hasOthers = newValue.some((v) => v !== "Todos");

							// Se clicou em "Todos" e houver outros => mantém só "Todos"
							if (includesTodos && hasOthers) {
								newValue = ["Todos"];
							}

							// Se clicou em qualquer outro e "Todos" estava selecionado => remove "Todos"
							if (hasOthers && filters[field.key]?.includes("Todos")) {
								newValue = newValue.filter((v) => v !== "Todos");
							}

							if (newValue.includes("according")) {
								newValue = newValue.filter((v) => v !== "according");
								const alreadyAllIncluded = SUBSTATUS_VALUES.every((s) => newValue.includes(s));
								newValue = alreadyAllIncluded
									? newValue.filter((v) => !SUBSTATUS_VALUES.includes(v))
									: Array.from(new Set([...newValue, ...SUBSTATUS_VALUES]));
							}

							if (newValue.length === 0) {
								newValue = ["open"];
							}

							setFilter(field.key, newValue);
							onChangeExternal?.(newValue, filters, setFilter);
							field.onChange?.(newValue, filters, setFilter);
						} else {
							const newValue = (e.target.value as string).trim();
							setFilter(field.key, newValue);
							onChangeExternal?.(newValue, filters, setFilter);
							field.onChange?.(newValue, filters, setFilter);
						}
					}}
					input={<OutlinedInput label={field.label} />}
					renderValue={(selected) =>
						isMultiple ? (
							<Box sx={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
								{(selected as string[]).map((val) => (
									<Chip key={val} label={getLabelFromValue(val, field).trim()} size="small" />
								))}
							</Box>
						) : (
							getLabelFromValue(selected as string, field)
						)
					}
				>
					{field.options?.map((opt) => (
						<MenuItem
							key={opt.value}
							value={opt.value}
							disabled={opt.isGroup}
							sx={{
								fontWeight: opt.isGroup ? "bold" : "normal",
								fontStyle: opt.isGroup ? "italic" : "normal",
								color: opt.isGroup ? "text.secondary" : "inherit",
								pl: opt.group === "according" ? 4 : 2,
								borderTop: opt.isGroup ? 1 : 0,
							}}
						>
							{opt.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Grid>
	);
}
